const de = {
    nav: {
        brand: 'donata oppermann',
        about: 'über mich',
        contact: 'kontakt',
        home: 'startseite',
        categories: 'Kategorien',
        switchTo: 'Sprache wechseln zu Englisch',
    },
    home: {
        sold: 'Verkauft',
        categories: {
            objekte: 'Objekte',
            zeichnungen: 'Zeichnungen',
            schalen: 'Schalen',
            schmuck: 'Schmuck',
            shop: 'Shop',
            urnen: 'Urnen',
        },
        shop: {
            filters: 'Filter',
            allCategories: 'Alle',
            price: {
                label: 'Preis',
                all: 'Alle Preise',
                under100: 'bis 100 €',
                '100to300': '100 – 300 €',
                over300: 'über 300 €',
            },
            sort: {
                label: 'Sortieren',
                newest: 'Neueste',
                featured: 'Empfohlen',
                priceAsc: 'Preis aufsteigend',
                priceDesc: 'Preis absteigend',
                nameAsc: 'Name A – Z',
            },
            results: (n) => (n === 1 ? '1 Werk' : `${n} Werke`),
            clear: 'Filter zurücksetzen',
            empty: 'Keine Werke entsprechen Ihrer Auswahl.',
            sold: 'verkauft',
            typeLabels: {
                Objekte: 'Objekte',
                Zeichnungen: 'Zeichnungen',
                Schmuck: 'Schmuck',
                Schalen: 'Schalen',
            },
        },
    },
    about: {
        eyebrow: 'über mich',
        name: { first: 'donata', last: 'oppermann' },
        role: 'künstlerin für dreidimensionale objekte und rauminstallationen',
        cue: 'scrollen',
        manifesto: {
            partA: 'meine objekte sind zeichnungen im raum.',
            partB: 'der faden ist hier die linie.',
            attribution: 'donata oppermann',
        },
        sections: [
            {
                title: 'mein künstlerischer weg',
                text: 'Schon immer war es mir wichtig, mit meinen Händen zu arbeiten. Ich liebe es, alte Handarbeitstechniken zu erforschen und dabei neue Wege zu entdecken. Für mich ist das Arbeiten mit den Händen eine Art, die Welt zu begreifen und zu verstehen. Es ist erstaunlich, was meine Hände, meine Seele, mein Geist und meine Sinne dabei alles hervorbringen können. Diese Freiheit in der Handarbeit führt oft zu überraschenden und beglückenden Ergebnissen. Manchmal bin ich selbst erstaunt, was sich dabei entwickelt.',
                caption: 'atelierarbeit — licht & schatten',
                alt: 'kunstwerk mit licht und schatten',
            },
            {
                title: 'raumobjekte',
                text: 'Meine größeren Arbeiten sind Raumobjekte aus Papiergarn, das ich an der Nähmaschine zusammenfüge. Inspiriert von der Natur, verwandle ich das Material in große, geheimnisvoll anmutende Wesen. Diese Objekte sind wie Zeichnungen im Raum, wobei der Faden die Linie darstellt. Die Linie spielt in meiner Arbeit eine zentrale Rolle. Sie steht für Schönheit, Bewegung, Abbruch, Aufbruch, Innehalten und Sich-Ausdehnen. Ich gewinne sie aus der Vielfalt der Natur, zeichne sie teils bewusst, teils unbewusst, und führe sie dann zum Objekt zurück.',
                caption: 'papiergarn — der faden als linie',
                alt: 'donatas kreativer prozess',
            },
            {
                title: 'wandobjekte und installationen',
                text: 'In einer anderen Serie arbeite ich mit kleinen, aufeinander bezogenen Wandobjekten. Hier kombiniere ich Gegenstände wie Puppenbeine aus Porzellan oder Rehgeweihe mit unbestimmbaren organischen Formen aus gehäkeltem Papier. Das Ergebnis sind surreal anmutende Objekte, die trotz ihrer komischen Erscheinung an albtraumhafte Szenen erinnern können. Eine meiner Raumarbeiten stellt eine Verbindung zwischen magischer, europäischer Vorgeschichte und aktuellen Umweltproblemen her. Dabei stelle ich den hohen Goldhüten prähistorischer Sonnenkulte solche aus Plastikabfall gegenüber.',
                caption: 'wandobjekte — fundstücke & gehäkeltes papier',
                alt: 'wandobjekte und installationen',
            },
            {
                title: 'papier-raumobjekte',
                text: 'In einer weiteren Reihe arbeite ich mit kubischen Raumfragmenten aus geschöpftem, brüchigem Papier. Diese Objekte reagieren sowohl aufeinander als auch auf den umgebenden Raum. Sie erzeugen Gefühle von Offenheit und Geborgenheit, aber auch von Leere und Schutzlosigkeit. Diese Arbeiten verweisen auf die Bedeutung von Architektur als Schutzraum und als erweiterten menschlichen Körper.',
                caption: null,
                alt: null,
            },
        ],
        outro: 'weitere arbeiten ansehen',
    },
    contact: {
        eyebrow: 'atelier',
        title: 'kontakt',
        description:
            'Nehmen Sie Kontakt mit Donata Oppermann auf, um über Auftragsarbeiten, Werke, Preise oder Ausstellungsmöglichkeiten zu sprechen.',
        channelsTitle: 'direkt',
        email: 'E-Mail',
        instagram: 'Instagram',
        location: 'Atelier',
        fields: {
            name: 'Name',
            email: 'E-Mail',
            message: 'Nachricht',
            placeholder: {
                name: 'Ihr Name',
                email: 'ihre@email.de',
                message: 'Womit kann ich Ihnen helfen?',
            },
        },
        send: 'Nachricht senden',
        thankYou: 'vielen dank',
        messageSent: 'Ihre Nachricht wurde erfolgreich übermittelt. Ich melde mich so bald wie möglich.',
        backToHome: 'zurück zur übersicht',
        error: 'Es gab einen Fehler beim Senden Ihrer Nachricht. Bitte versuchen Sie es später erneut.',
        addressLabel: 'Forststrasse 7, 92369 Sengenthal',
    },
    product: {
        loading: 'Wird geladen…',
        notFound: 'Werk nicht gefunden',
        loadError: 'Das Werk konnte nicht geladen werden',
        contactForPrice: 'Preis auf Anfrage',
        sale: 'Angebot',
        promo: {
            title: 'Rabattcode',
            placeholder: 'Code eingeben',
            apply: 'Einlösen',
            applying: '…',
            invalid: 'Code ungültig oder nicht anwendbar',
            error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
            discount: 'Rabatt',
            remove: 'Entfernen',
            automatic: 'Aktion',
        },
        measurements: 'Abmessungen',
        details: 'Details',
        specs: {
            material: 'Material',
            dimensions: 'Abmessungen',
            weight: 'Gewicht',
            origin: 'Herkunft',
            category: 'Kategorie',
            collection: 'Serie',
            technique: 'Technik',
            year: 'Jahr',
            series: 'Werkreihe',
            benefits: 'Besonderes',
            edition: 'Auflage',
            signature: 'Signatur',
            condition: 'Zustand',
            framed: 'Gerahmt',
            exhibitions: 'Ausstellungen',
        },
        related: {
            eyebrow: 'weitere',
            title: 'arbeiten der serie',
            empty: 'keine weiteren arbeiten',
        },
        breadcrumb: {
            back: 'zurück zur übersicht',
        },
        gallery: {
            zoom: 'zum vergrößern klicken',
            counter: (i, n) => `${String(i).padStart(2, '0')} / ${String(n).padStart(2, '0')}`,
            thumbAlt: (title, i) => `${title} – Detailansicht ${i}`,
            close: 'Schließen',
            previous: 'Vorheriges Bild',
            next: 'Nächstes Bild',
        },
        stock: {
            inStock: 'auf lager',
            fewLeft: (n) => `nur noch ${n} verfügbar`,
            soldOut: 'ausverkauft',
        },
        cta: {
            buy: 'jetzt erwerben',
            request: 'preis anfragen',
        },
        priceRequest: {
            title: 'preisanfrage',
            description: 'Schreiben Sie mir – ich melde mich persönlich bei Ihnen.',
            name: 'Name',
            email: 'E-Mail',
            message: 'Nachricht (optional)',
            messagePlaceholder: 'Ihre Nachricht …',
            submit: 'anfrage senden',
            submitting: 'wird gesendet …',
            success: 'Vielen Dank für Ihre Anfrage. Ich melde mich schnellstmöglich bei Ihnen.',
            errors: {
                nameRequired: 'Name ist erforderlich',
                emailRequired: 'Gültige E-Mail ist erforderlich',
            },
        },
        contactOverlay: {
            title: 'Hallo!',
            subtitle: 'Ich beantworte gerne Ihre Fragen zu diesem Werk',
            email: 'E-Mail schreiben',
            contactPage: 'Kontaktseite besuchen',
            mailSubject: (title) => `Anfrage: ${title}`,
            mailBody: (title) =>
                `Hallo! Ich interessiere mich für das Werk "${title}" und hätte folgende Frage:`,
            buttonAria: 'Kontakt-Overlay öffnen',
        },
        address: {
            title: 'lieferadresse',
            name: 'Name',
            namePlaceholder: 'Vollständiger Name',
            nameRequired: 'Name wird benötigt',
            email: 'E-Mail',
            emailPlaceholder: 'ihre@email.de',
            emailRequired: 'E-Mail wird benötigt',
            emailInvalid: 'Ungültige E-Mail-Adresse',
            line1: 'Straße und Hausnummer',
            line1Placeholder: 'Musterstraße 123',
            line1Required: 'Adresse wird benötigt',
            postal: 'PLZ',
            postalPlaceholder: '12345',
            postalRequired: 'PLZ wird benötigt',
            city: 'Stadt',
            cityPlaceholder: 'Berlin',
            cityRequired: 'Stadt wird benötigt',
            country: 'Land',
            countryPlaceholder: 'Land auswählen',
            countrySearch: 'Land suchen …',
            countryEmpty: 'Kein Land gefunden',
            countryRequired: 'Land wird benötigt',
            continue: 'weiter zum versand',
            processing: 'wird verarbeitet …',
        },
        shipping: {
            title: 'versandart',
            subtitle: 'Wählen Sie Ihre bevorzugte Versandart. Die Kosten richten sich nach dem Lieferland.',
            continue: 'weiter zur zahlung',
            processing: 'wird verarbeitet …',
            back: 'zurück zur adresse',
            free: 'Kostenlos',
            none: 'Für dieses Land ist derzeit kein Versand verfügbar. Bitte kontaktieren Sie uns.',
        },
        payment: {
            title: 'zahlung',
            orderFor: 'Bestellung für',
            email: 'E-Mail',
            shippingTo: 'Lieferadresse',
            summary: {
                item: 'Artikel',
                shipping: 'Versand',
                discount: 'Rabatt',
                total: 'Gesamt',
                free: 'Kostenlos',
            },
            pay: (amount) => `${amount} bezahlen`,
            processing: 'wird bearbeitet …',
            confirmation: 'Nach erfolgreicher Zahlung erhalten Sie eine Bestätigungs-E-Mail.',
            preparing: 'Zahlung wird vorbereitet …',
            initFailed: 'Zahlungssystem konnte nicht initialisiert werden. Bitte später erneut versuchen.',
            errorTitle: 'Fehler bei der Zahlung',
            stripeNotReady: 'Stripe ist noch nicht initialisiert. Bitte einen Moment warten.',
            errors: {
                cardError: 'Es gab ein Problem mit Ihrer Karte.',
                emptyParam: 'Bitte füllen Sie alle erforderlichen Felder aus.',
                invalidRequest: 'Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Eingaben.',
                apiError: 'Ein Serverfehler ist aufgetreten. Bitte später erneut versuchen.',
                generic: 'Ein unerwarteter Fehler ist aufgetreten.',
            },
        },
        purchase: {
            success: 'Vielen Dank für Ihren Einkauf! Wir bearbeiten Ihre Bestellung umgehend.',
            errorFallback: 'Fehler bei der Bestellung. Bitte erneut versuchen.',
            noShipping: 'Keine Versandart verfügbar.',
            noStripe: 'Stripe-Sitzung konnte nicht erstellt werden.',
            noVariant: 'Produkt hat keine Variante.',
            freeOrderTitle: 'Bestellung abschließen',
            freeOrderNote: 'Durch die Aktion ist Ihr Gesamtbetrag 0 €. Es ist keine Zahlung nötig.',
            freeOrderCta: 'Kostenlos bestellen',
        },
    },
    faq: {
        eyebrow: 'Hilfe & Versand',
        title: 'Häufige Fragen',
        subtitle: 'Antworten rund um Versand, Verpackung und Bestellung.',
        questionsHeading: 'Weitere Fragen',
        shipping: {
            heading: 'Versandkosten',
            intro: 'Die Versandkosten richten sich nach Größe und Art des Werks und werden im Checkout nach Eingabe der Lieferadresse angezeigt. Es gelten folgende Pauschalen:',
            columns: { category: 'Kategorie', de: 'Deutschland', eu: 'EU', world: 'Weltweit' },
            rows: [
                { category: 'Schmuck & Kleinteile', de: '4,99 €', eu: '6,99 €', world: '13,90 €' },
                { category: 'Objekte, Zeichnungen & Schalen', de: '6,99 €', eu: '16,90 €', world: '39,90 €' },
                { category: 'Große & sperrige Werke', de: '14,90 €', eu: '29,90 €', world: '59,90 €' },
            ],
            note: 'Jedes Werk ist ein Unikat. Bei besonders großen oder gerahmten Arbeiten stimme ich den Versand bei Bedarf individuell mit Ihnen ab.',
        },
        items: [
            {
                question: 'Wie lange dauert der Versand?',
                answer: 'Jedes Werk wird von Hand gefertigt und einzeln verpackt. Nach Zahlungseingang versende ich in der Regel innerhalb von 3–5 Werktagen. Die Laufzeit beträgt anschließend innerhalb Deutschlands 1–3 Werktage, innerhalb der EU 3–7 Werktage und weltweit je nach Zielland entsprechend länger.',
            },
            {
                question: 'Wie werden die Werke verpackt?',
                answer: 'Alle Arbeiten werden sorgfältig und bruchsicher verpackt. Empfindliche und gerahmte Werke erhalten zusätzlichen Schutz, damit sie unversehrt bei Ihnen ankommen.',
            },
            {
                question: 'Versenden Sie auch ins Ausland?',
                answer: 'Ja. Ich versende innerhalb Deutschlands, in die EU und weltweit. Die jeweiligen Versandkosten sehen Sie in der Tabelle oben sowie im Checkout.',
            },
            {
                question: 'Ein Werk ist als „Preis auf Anfrage“ gekennzeichnet – wie kann ich es erwerben?',
                answer: 'Einige Arbeiten sind nicht direkt über den Shop erhältlich. Nutzen Sie bei diesen Werken einfach das Anfrageformular auf der jeweiligen Produktseite – ich melde mich persönlich bei Ihnen.',
            },
            {
                question: 'Wie kann ich bezahlen?',
                answer: 'Die Bezahlung erfolgt sicher über Stripe, unter anderem mit gängigen Kredit- und Debitkarten.',
            },
        ],
    },
};

export default de;
